import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RecommendPage from "../pages/category/recommend/page";
import NewsCategoryPage from "../pages/category/news/page";
import CharacterCategoryPage from "../pages/category/characters/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import SpecialPage from "../pages/special/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/recommend",
    element: <RecommendPage />,
  },
  {
    path: "/category/news",
    element: <NewsCategoryPage />,
  },
  {
    path: "/category/characters",
    element: <CharacterCategoryPage />,
  },
  {
    path: "/detail/:id",
    element: <DetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/special/:id",
    element: <SpecialPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;